import React from 'react';

export const PAGE_META = {
  overview:    { title: 'Executive Overview',  crumb: 'Workspace', parent: 'Overview' },
  product:     { title: 'Product Performance', crumb: 'Workspace', parent: 'Catalog' },
  salesperson: { title: 'Salesperson',         crumb: 'Workspace', parent: 'Sales' },
};

const TopBar = ({ active }) => {
  const meta = PAGE_META[active] || PAGE_META.overview;
  return (
    <div className="topbar">
      <div>
        <div className="crumb">
          <span>{meta.crumb}</span>
          <span className="sep">/</span>
          <span>{meta.parent}</span>
        </div>
        <h1>{meta.title}</h1>
      </div>
      <div className="topbar-spacer" />
    </div>
  );
};

export default TopBar;
